class MobileMenu {
	constructor() {
		const openHeader = document.querySelector(".open-mobile-menu");
		openHeader.addEventListener("click", () => {
			document.body.classList.toggle("main-menu-open");
		});
	}
}
